import { asyncActionType } from "app/utils";

export const LOGIN = asyncActionType("@auth/LOGIN");
export const SIGN_UP = asyncActionType("@auth/SIGN_UP");
export const ACTIVATION = asyncActionType("@auth/ACTIVATION");
export const RESET = asyncActionType("@auth/RESET");
export const USER_INFO = asyncActionType("@auth/USER_INFO");
export const LOGOUT = "@auth/LOGOUT";
export const RESET_FORM = "@auth/RESET_FORM";

export const API_BASE_URL = "/api/auth/v1";



// WEBPACK FOOTER //
// ./src/app/auth/constants.js